export const EMBEDDED_URL_PROPERTY_NAME = 'EntityExtraction/EmbeddedUrl1.0';
export const URL_PROPERTY_NAME = 'EntityExtraction/Url1.0';
